import { render, staticRenderFns } from "./HojaCargaIndex.vue?vue&type=template&id=52c5e430"
import script from "./HojaCargaIndex.vue?vue&type=script&lang=js"
export * from "./HojaCargaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports